<template>
    <section class="content">
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <h4>Loading...</h4>
      </div>
      
      <div class="box box-info">
          <form>
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-2">
                  <label for="fromDate">From Date</label>
                  <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                  <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
                </div>
    
                <div class="p-field p-col-12 p-md-2">
                  <label for="toDate">To Date</label>
                  <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                  <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
                </div>
                <div class="p-field p-col-12 p-md-1 p-mt-5">
                  <Button @click.prevent="searchInvoices" class="p-button-raised" label="Search"
                    icon="pi pi-search" />
                </div>
              </div>
            </form>
        <DataTable :value="invoiceList" ref="po" :paginator="true" :rows="100" editMode="cell"
                  :rowsPerPageOptions="[100, 500, 1000]" :filters="filters"
                  class="p-datatable-responsive p-datatable-gridlines" data-key="id"
                  :selection.sync="selectedProduct1" selectionMode="single">
          <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV" />
            </div>
          </template>
          
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>
          
          <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
            </template>
          </Column>
          
          <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
            </template>
          </Column>
          
          <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
            </template>
          </Column>
          
          <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
            <template #body="slotProps">
              {{ slotProps.data.accountMaster.name }}
            </template>
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
            </template>
            <template #footer>
              Total:
            </template>
          </Column>
          
          <Column header="Contact No" :sortable="true" field="contactNumber" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>
  
          <Column header="Payment Date" headerStyle="width:8em;" :sortable="true" field="creditDueDateNepali"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['creditDueDateNepali']" />
            </template>
          </Column>

           <Column header="Remarks"  >
                  <template #body="slotProps">
                    <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Remarks'"
                      @click="showMessageDialog(slotProps.data)" ><span class="pi pi-envelope"></span></Button>
                  </template>
                </Column>
  
          <Column header="Action">
            <template #body="slotProps">
              <Button class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                      @click="viewInvoiceDetail(slotProps.data)">
                <span class="fa fa-eye"></span>
              </Button>
            </template>
          </Column>
  
          <Column header="Credit Days" bodyStyle="text-align: right" field="creditDays" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['creditDays']"/>
                  </template>
                  <template #editor="slotProps">
                    <InputText type="text" class="p-column-filter" v-model="slotProps.data['creditDays']" @change="updatePaymentStatus(slotProps.data)"/>
                  </template>
           </Column>
          
          <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['address']" />
            </template>
          </Column>
          
          <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']" />
            </template>
          </Column>
      
          <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
            </template>
            <template #footer>
              {{ totalSumBillAmount.toFixed(2) }}
            </template>
          </Column>
          
          <Column header="Pay status" bodyStyle="text-align: right" field="paymentStatus" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']"/>
                  </template>
                  <template #editor="slotProps">
                    <Dropdown v-model="slotProps.data['paymentStatus']" :options="statusesPay"
                              @change="updatePaymentStatus(slotProps.data)"
                              optionLabel="label" optionValue="value" placeholder="Select a Status">
                      <template #option="slotProps">
                        <span>{{ slotProps.option.label }}</span>
                      </template>
                    </Dropdown>
                  </template>
                  <template #body="slotProps">
                    {{ getPayStatusLabel(slotProps.data.paymentStatus) }}
                  </template>
                </Column>
                <Column header="Pay Method" bodyStyle="text-align: right" field="paymentMethod" :sortable="true"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['paymentMethod']"/>
                  </template>
                  <template #editor="slotProps">
                    <Dropdown v-model="slotProps.data['paymentMethod']" :options="payMethods"
                              @change="updatePaymentStatus(slotProps.data)"
                              optionLabel="label" optionValue="value" placeholder="Select a Status">
                      <template #option="slotProps">
                        <span>{{ slotProps.option.label }}</span>
                      </template>
                    </Dropdown>
                  </template>
                  <template #body="slotProps">
                    {{ getPaymentMethodLabel(slotProps.data.paymentMethod) }}
                  </template>
                </Column>
          
          <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
            </template>
          </Column>
          
          
          <template #empty>No invoices found</template>
        </DataTable>
      </div>
      <Dialog
        :visible="receivedMessageDialog"
        :style="{ width: '500px' }"
        :modal="true"
        class="p-fluid"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="remarks">Remarks <span style="color:red">*</span></label>
            <Textarea
              id="remarks"
              v-model="paymentRemarks"
              rows="12"
              autoResize
            />
            <small style="color: #e74c3c; font-style: italic; display: block; margin-top: 4px;">
              For date in remarks, enter in format like <strong>2082-04-29</strong>, not 2082/04/29
            </small>
          </div>
          <!-- <div class="p-col-12 p-md-6">
            <div class="p-grid">
              <div class="p-field p-col-6">
                <label>Next Follow-up Date</label>
                <date-picker
                  v-model="nextFollowUpDate"
                  valueType="format"
                  v-if="!englishDateEnabled"
                />
                <input-mask
                  mask="9999-99-99"
                  class="nepali-calendar"
                  id="nextFollowUpDate"
                  v-model="nextFollowUpDate"
                  v-else
                />
              </div>
              <div class="p-field p-col-6">
                <label>Cheque Date</label>
                <date-picker
                  v-model="chequeDate"
                  valueType="format"
                  v-if="!englishDateEnabled"
                />
                <input-mask
                  mask="9999-99-99"
                  class="nepali-calendar"
                  id="chequeDate"
                  v-model="chequeDate"
                  v-else
                />
              </div>
              <div class="p-field p-col-6">
                <label>Follow-up Time</label>
                <Calendar 
                  id="followUpTime" 
                  v-model="followUpTime" 
                  :timeOnly="true" 
                  :hourFormat="'24'"
                  :showIcon="true"
                  :stepMinute="5"
                  placeholder="Select Time"
                />
              </div> -->
              <div class="p-col-6"></div>
            </div>
          </div>
        </div>
        <template #footer>
          <!-- <Button
            label="Save"
            icon="pi pi-check"
            class="p-button p-button-raised p-button-primary"
            @click="updatePaymentRemarks"
          /> -->
          <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button p-button-raised p-button-danger"
            @click="closeDialog"
          />
        </template>
      </Dialog>
    </section>
  </template>
  
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import Dropdown from 'primevue/dropdown'
  import Dialog from 'primevue/dialog/Dialog'
  import Textarea from 'primevue/textarea/Textarea'
  import $ from 'jquery'
  export default {
    name: 'SalesInvoicePaymentStatusReport',
    props: ['status'],
    data() {
      return {
        fromDate: null,
        toDate: null,
        loading: false,
        selectedProduct1: null,
        filters: {},
        receivedMessageDialog: false,
        paymentRemarks: '',
        englishDateEnabled: true,
        totalSumBillAmount: 0,
        statusesPay: [
          {label: 'Paid', value: 'Paid'},
          {label: 'Unpaid', value: 'Unpaid'}
        ],
        payMethods: [
          {label: 'Cash', value: 'CASH'},
          {label: 'Esewa', value: 'ESEWA'},
          {label: 'Prabhu Bank', value: 'PRABHU'},
          {label: 'Nic Bank', value: 'NIC'}
        ]
      }
    },
    computed: {
      invoiceList() {
        return this.$store.state.sales.salesTodysPaymentFollowUpLists
      }
    },
    mounted() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
          this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    methods: {
      async searchInvoices() {
        this.loading = true
        try {
          const data = {
            fromDate: this.fromDate,
            toDate: this.toDate
          }
          const resp = await this.$store.dispatch('loadSalesPaymentTodaysFollowUp', data)
          if (resp.data.data.length <= 0) {
            this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
          } else {
            this.invoiceList = resp.data.data
            this.totalBalance()
          //  this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
          }
        } catch (error) {
          console.error('Error fetching data:', error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load data',
            life: 3000
          })
        } finally {
          this.loading = false
        }
      },
    //   async viewInvoiceDetail(data) {
    //     let PIHdata = {
    //       id: data.id,
    //       warehouse: data.warehouse,
    //       account: data.accountMaster,
    //       salesDate: data.purchaseSalesDateNepali,
    //       billNo: data.billNo,
    //       reportType: data.reportType,
    //       referenceNumber: data.referenceNumber,
    //       subTotalAmount: data.subTotalAmount,
    //       nonTaxableAmount: data.nonTaxableAmount,
    //       taxableAmount: data.taxableAmount,
    //       vatAmount: data.vatAmount,
    //       totalBillAmount: data.totalBillAmount,
    //       vatTypeEnum: data.vatTypeEnum,
    //       exciseChargeAmount: data.exciseChargeAmount,
    //       discountAmt: data.discount,
    //       remarks: data.remarks
    //     }
    //   if (data.purchaseType !== 'dairy') {
    //     this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
    //   } else {
    //     this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
    //   }
    // },
      async updatePaymentStatus(data) {
        let payment = {
          id: data.id,
          status: data.paymentStatus,
          method: data.paymentMethod,
          creditDays: data.creditDays
        }
        let response = await this.$store.dispatch('paymentSalesStatusUpdate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Payment Status' + response.data.message,
            life: 3000
          })
        }
      },
      getPaymentMethodLabel(payMethods) {
        switch (payMethods) {
          case 'ESEWA':
            return 'Esewa'
          case 'CASH':
            return 'Cash'
          case 'PRABHU BANK':
            return 'prabhu'
          case 'NIC BANK':
            return 'nic'
          default:
            return 'NA'
        }
      },
      getPayStatusLabel(payStatus) {
        switch (payStatus) {
          case 'Paid': return 'Paid'
          case 'Unpaid': return 'Unpaid'
          default: return 'NA'
        }
      },
      showMessageDialog(data) {
        this.paymentRemarks = data.paymentRemarks
        // this.nextFollowUpDate = data.nextFollowUpDate
        // this.chequeDate = data.chequeDate
        // this.followUpTime = data.followUpTime
        this.id = data.id
        this.receivedMessageDialog = true
      },
      closeDialog() {
        this.paymentRemarks = ''
        // this.nextFollowUpDate = null
        // this.chequeDate = null
        // this.followUpTime = null
        this.receivedMessageDialog = false
      },
      async updatePaymentRemarks() {
        if (!this.paymentRemarks || this.paymentRemarks.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Remarks cannot be empty!', life: 10000})
          return
        }
        let payment = {
          id: this.id,
          remarks: this.paymentRemarks,
          followUpDate: this.nextFollowUpDate,
          chequeDate: this.chequeDate,
          followUpTime: this.cleanTimeFormat(this.followUpTime)
        }
        let response = await this.$store.dispatch('paymentSalesRemarksAndDate', payment)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({
            severity: 'success',
            summary: '',
            detail: 'Payment Status' + response.data.message,
            life: 3000
          })
          this.receivedMessageDialog = false
          await this.salesInvoiceUnpaidList()
        }
      },
      async viewInvoiceDetail(data) {
        let PIHdata = {
          id: data.id,
          warehouse: data.warehouse,
          account: data.accountMaster,
          salesDate: data.purchaseSalesDateNepali,
          billNo: data.billNo,
          reportType: data.reportType,
          referenceNumber: data.referenceNumber,
          subTotalAmount: data.subTotalAmount,
          nonTaxableAmount: data.nonTaxableAmount,
          taxableAmount: data.taxableAmount,
          vatAmount: data.vatAmount,
          totalBillAmount: data.totalBillAmount,
          vatTypeEnum: data.vatTypeEnum,
          exciseChargeAmount: data.exciseChargeAmount,
          discountAmt: data.discount,
          remarks: data.remarks
        }
        if (data.purchaseType !== 'dairy') {
          this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
        } else {
          this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
        }
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      totalBalance() {
        this.totalSumBillAmount = this.invoiceList.reduce(
          (sum, item) => sum + (item.totalBillAmount || 0),
          0
        )
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      InputText,
      Button,
      InputMask,
      Dropdown,
      Dialog,
      Textarea
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css">
  </style>



// WEBPACK FOOTER //
// salesPaymentTodysFollowUp.vue?10122cf2